export enum GetConversationsOrigin {
    Manage,
    MyHome,
    MyViewings,
    SupplierPlatform,
    OwnerPlatform
}
